import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { UserContext } from '../../../context/user-context';
import { useParams } from 'react-router';
import moment from 'moment';
import useBreadcrumbs from 'use-react-router-breadcrumbs';

import { Breadcrumb, Col, Container, Image, Row } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { FaArrowRight } from 'react-icons/fa';

import EventsTicketContainer from '../../../components/events/tickets-container';
import EventInfoForm from '../../../components/events/info-form';
import { ContentState, EditorState, convertFromHTML, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html'

export default function Edit({}) {
  const breadcrumbs = useBreadcrumbs();
  const { userToken, user } = useContext(UserContext)
  const [step, setStep] = useState(1)
  const [name, setName] = useState('')
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [venueName, setVenueName] = useState(null)
  const [venueAddress, setVenueAddress] = useState(null)
  const [flyerImage, setFlyerImage] = useState(null)
  const [flyerImagePreview, setFLyerImagePreview] = useState(null)
  const [eventTickets, setEventsTickets] = useState([])
  const [eventDetailFormIsValid, setEventDetailFormIsValid] = useState(false)
  const [description, setDescription] = useState(EditorState.createEmpty())
  const [savingEvent, setSavingEvent] = useState(false)
  const { event_id } = useParams();

  useEffect(()=>{
    getEvent()
  },[])
  
  useEffect(() => {
    if (flyerImage) {
      var reader = new FileReader()
      var url = reader.readAsDataURL(flyerImage[0])
      reader.onloadend = function (e) {
        setFLyerImagePreview(reader.result)
      }
    }
  }, [flyerImage])

  useEffect(() => {
    setEventDetailFormIsValid(false)
    if (name && startDate && endDate && venueAddress && flyerImagePreview) {
      setEventDetailFormIsValid(true)
    }
  }, [name, startDate, endDate, venueAddress, flyerImagePreview])

  const getEvent = () => {    
    axios.get(process.env.REACT_APP_API_BASE_URL + '/wp-json/gnetwork/v1/events/'+event_id, {
      headers: {
        'Authorization': 'Basic ' + btoa(user.user_login+":"+userToken),
      }
    }).then(res=>{
      const event = res.data.event
      console.log(event)
      setName(event.name)
      const contentBlocks = convertFromHTML(event.description);
      setDescription(EditorState.createWithContent(ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      )))
      setStartDate(moment(event.duration_start_day+" "+event.duration_start_time, "YYYY-MM-DDTHH:mm").format("YYYY-MM-DDTHH:mm"))
      setEndDate(moment(event.duration_end_day+" "+event.duration_end_time, "YYYY-MM-DDTHH:mm").format("YYYY-MM-DDTHH:mm"))
      setVenueAddress(event.google_maps_address.title)
      if (event.thumbnail) {
        setFLyerImagePreview(event.thumbnail[0])
      }
      console.log(res.data.tickets)
      let _tickets = []
      for (let i = 0; i < res.data.tickets.length; i++) {
        const _ticket = res.data.tickets[i];
        _tickets.push({
          name:_ticket.name,
          price: parseFloat(_ticket.price),
          quantity: _ticket.max_qty,
          unlimitedTicketsQuantity: (_ticket.max_qty === ''?true:false),
          description: _ticket.description
        })
      }
      console.log(_tickets)
      setEventsTickets(_tickets)
    }).catch(err=>{
      console.log(err.message)
      alert('Error!! Check Logs.');
    })
  }

  const updateEvent = () => {
    const form = new FormData()
    form.set('name', name);
    if (description) {
      form.set('description', draftToHtml(convertToRaw(description.getCurrentContent())));
    }
    form.set('startDate', startDate);
    form.set('endDate', endDate);
    form.set('venueName', venueName);
    form.set('venueAddress', venueAddress);
    if (flyerImage) {
      form.set('flyerImage', flyerImage[0], flyerImage.name);
    }
    // console.log(form)
    const _user = JSON.parse(localStorage.getItem(process.env.REACT_APP_USER_LOCALSTOAGE_KEY));
    const _userToken = localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN_LOCALSTOAGE_KEY);
    setSavingEvent(true);
    const post_status = form.get('status');
    axios.post(process.env.REACT_APP_API_BASE_URL + '/wp-json/gnetwork/v1/events/'+event_id, form, {
      headers: {
        'Authorization': 'Basic ' + btoa(_user.user_login  +  ":"  +  _userToken),
        'Content-Type': 'multipart/form-data'
      }
    }).then((res) => {
      console.log(res.data);
      alert('Saved ' + post_status + ' event.');
      // window.location.reload();
      window.location = '/events';
    }).catch((err) => {
      console.log(err.message);
      alert('Failed to ' + post_status + ' event.');
    }).finally(() => {
      setSavingEvent(false);
    });
  }
  return (
    <Container>
      <section className='create-event'>
        <Breadcrumb>
        {
          breadcrumbs.map(({ breadcrumb, key, location, match }, index) => {
            breadcrumb = ((key === ('/events/'+event_id))?name:breadcrumb)
            return <Breadcrumb.Item key={index} href={key}>{breadcrumb}</Breadcrumb.Item>
          })
        }
        </Breadcrumb>
        <div className='p-relative'>
          {step === 1 && (
            <Row className="mb-3">
              <Col md="6">
                <h3>Event Details</h3>
                <EventInfoForm
                  name={name}
                  startDate={startDate}
                  endDate={endDate}
                  venueName={venueName}
                  venueAddress={venueAddress}
                  flyerImage={flyerImage}
                  setName={setName}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  setVenueName={setVenueName}
                  setVenueAddress={setVenueAddress}
                  setFlyerImage={setFlyerImage}
                  description={description}
                  setDescription={setDescription}
                  editMode={true}
                />
                <Button
                  variant='light'
                  disabled={!eventDetailFormIsValid || savingEvent}
                  onClick={updateEvent}>
                  Update
                </Button>
              </Col>
              <Col md="6">
                {flyerImagePreview ? <Image src={flyerImagePreview} style={{width:'100%'}}/> : (
                  <Card>
                    <Card.Body className='text-center'>Select the Flyer Image to see the preview of it.</Card.Body>
                  </Card>
                )}
              </Col>
            </Row>
          )}
        </div>
      </section>
    </Container>
  )
}
